import { AboutModel, AboutState } from './aboutModel';

export type AboutAction =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS'; payload: AboutModel }
  | { type: 'FETCH_ERROR'; payload: string }
  | { type: 'SET_PRODUCT_NAME'; payload: string }
  | { type: 'RESET' };

export const initialAboutState: AboutState = {
  model: AboutModel.initial(),
  loading: false,
  error: null,
  productName: ''
};

export const aboutReducer = (
  state: AboutState,
  action: AboutAction
): AboutState => {
  switch (action.type) {
    case 'FETCH_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_SUCCESS':
      return { ...state, model: action.payload, loading: false };

    case 'FETCH_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'SET_PRODUCT_NAME':
      return { ...state, productName: action.payload };

    case 'RESET':
      return initialAboutState;

    default:
      return state;
  }
};